/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import * as React from "react";

/**
 * Renders the icon to show when prerequisites are not met.
 * @returns The icon to show when prerequisites are not met.
 */
export const ThumbsUpIcon: React.VFC = () => {
    return (
        <svg width="198" height="201" viewBox="0 0 198 201" fill="none" xmlns="https://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_3365_75719)">
                <path
                    d="M62.1151 0.790712C61.5891 2.34052 60.618 3.6802 59.3389 4.64943C59.1146 4.81943 59.1013 5.13303 59.3129 5.31843C60.581 6.43015 61.5533 7.86711 62.1011 9.50059C62.2406 9.91621 62.7961 9.91621 62.9355 9.50053C63.4832 7.86723 64.4558 6.43021 65.7234 5.31855C65.935 5.13303 65.9216 4.81949 65.6974 4.64955C64.4183 3.68038 63.4471 2.34064 62.9208 0.790774C62.7891 0.403057 62.2466 0.403115 62.1151 0.790712Z"
                    fill="#FFFACF"
                />
                <path
                    d="M96.8195 184.782C135.03 184.782 166.006 153.806 166.006 115.596C166.006 77.3849 135.03 46.4089 96.8195 46.4089C58.6088 46.4089 27.6328 77.3849 27.6328 115.596C27.6328 153.806 58.6088 184.782 96.8195 184.782Z"
                    fill="#EDEBE9"
                />
                <path
                    d="M96.0142 54.1508C92.4752 51.1762 95.5953 44.4335 90.7053 37.3006L80.3489 38.7044L69.046 34.5867L64.6797 63.5409C64.6797 63.5409 66.0134 64.0129 74.7738 69.5165C78.9482 72.139 82.9595 72.1644 85.7515 72.394C87.0417 72.5001 120.589 91.8901 120.589 91.8901L134.668 71.763C134.668 71.763 96.9302 54.9207 96.0142 54.1508Z"
                    fill="url(#paint0_radial_3365_75719)"
                />
                <path
                    d="M90.7041 37.3006C85.2225 28.7597 83.5444 28.8973 84.3678 23.2627C85.1774 17.7231 79.0004 16.7546 77.5975 23.1197C76.0414 30.1792 78.8764 37.0256 80.3475 38.7044C80.3475 38.7044 75.7227 47.6595 81.4453 55.0639C87.6811 63.1322 91.6836 63.7723 91.6836 63.7723C91.6836 63.7723 94.6233 43.4075 90.7041 37.3006Z"
                    fill="#E0BB95"
                />
                <path
                    d="M74.0234 46.2177L67.0977 42.9977C64.403 41.619 62.8926 38.619 63.8602 36.3665C64.8279 34.1141 67.8297 33.6426 70.4335 35.2329L76.8765 38.7137C79.1951 39.846 80.0772 42.5743 79.1807 44.757C78.6101 46.1458 76.1132 47.2869 74.0234 46.2177Z"
                    fill="#E0BB95"
                />
                <path
                    d="M71.3305 53.0702L63.2313 49.7507C60.5571 48.6647 59.0295 45.9495 59.9512 43.7395C60.8729 41.5295 63.8225 40.8344 66.4121 42.1235L74.2095 46.1667C76.2285 47.1717 77.1801 49.4356 76.4176 51.2643C75.6549 53.0928 73.4155 53.9168 71.3305 53.0702Z"
                    fill="#E0BB95"
                />
                <path
                    d="M70.2619 59.5295L63.6834 57.959C61.1811 57.2964 58.8033 54.8469 59.9409 52.0461C60.8253 49.8689 62.3799 49.262 66.2517 50.6442L74.0687 53.3075C74.6435 53.4405 75.6958 55.4341 75.0632 57.2356C74.4307 59.0372 72.3148 60.073 70.2619 59.5295Z"
                    fill="#E0BB95"
                />
                <path
                    d="M67.4906 65.5847L64.8307 65.0354C62.4062 64.5139 60.7251 62.4504 61.1743 60.4477C61.6236 58.4449 64.0039 57.391 66.3939 58.0663L71.0543 59.5553C73.0383 60.1158 74.3215 62.1386 73.8884 63.6822C73.2584 65.929 71.6025 66.228 67.4906 65.5847Z"
                    fill="#E0BB95"
                />
                <path
                    d="M49.2663 78.3093C44.3921 74.2123 48.6894 64.9257 41.9545 55.1015L27.6905 57.035L12.9962 51.47L6.10938 91.2421C6.10938 91.2421 7.76434 90.7228 20.1629 97.8841C26.0425 101.28 33.6185 101.154 37.4639 101.471C39.2409 101.617 49.3471 107.389 58.38 112.7C67.259 107.41 70.5247 100.129 73.6784 89.9793C63.6536 85.4262 50.5278 79.3695 49.2663 78.3093Z"
                    fill="url(#paint1_radial_3365_75719)"
                />
                <path
                    d="M41.9543 55.1014C34.4046 43.338 33.0153 43.2115 33.2274 35.7672C33.4402 28.3012 25.4401 27.8535 23.9027 35.5703C21.7596 45.2932 26.511 54.8307 28.5372 57.1429C28.5372 57.1429 21.3206 69.3689 29.2024 79.5668C37.7908 90.6793 43.3037 91.5608 43.3037 91.5608C43.3037 91.5608 47.3523 63.5123 41.9543 55.1014Z"
                    fill="#BF8F68"
                />
                <path
                    d="M19.3225 66.7341L10.1833 62.485C6.62727 60.6656 4.63434 56.7068 5.91117 53.7346C7.1881 50.7623 11.1491 50.1399 14.5851 52.2386L23.0874 56.8318C26.1469 58.3259 27.311 61.9261 26.1278 64.8065C25.3751 66.6392 22.0801 68.145 19.3225 66.7341Z"
                    fill="#BF8F68"
                />
                <path
                    d="M15.7703 75.7767L5.08255 71.3964C1.55372 69.9634 -0.462123 66.3804 0.754084 63.4641C1.97029 60.5478 5.86276 59.6306 9.27985 61.3316L19.5692 66.667C22.2334 67.9931 23.4893 70.9806 22.4831 73.3937C21.4768 75.8065 18.5215 76.8939 15.7703 75.7767Z"
                    fill="#BF8F68"
                />
                <path
                    d="M14.3589 84.3003L5.67798 82.2279C2.37602 81.3536 -0.761758 78.1212 0.73948 74.4254C1.90651 71.5524 3.95792 70.7515 9.06731 72.5754L19.3826 76.0901C20.1411 76.2655 21.5297 78.8963 20.695 81.2736C19.8601 83.6506 17.0678 85.0175 14.3589 84.3003Z"
                    fill="#BF8F68"
                />
                <path
                    d="M10.7024 92.2907L7.19232 91.5657C3.99304 90.8776 1.77469 88.1545 2.36751 85.5117C2.96035 82.8689 6.10139 81.4783 9.25515 82.3693L15.4051 84.3341C18.023 85.0736 19.7164 87.7428 19.145 89.78C18.3135 92.7451 16.1284 93.1395 10.7024 92.2907Z"
                    fill="#BF8F68"
                />
                <path
                    d="M103.293 169.179C103.293 169.179 60.6373 151.273 59.6739 150.463C55.9519 147.334 59.2334 140.243 54.0905 132.741L43.1765 134.247L34.0992 130.107L29.6836 160.531C29.6836 160.531 31.0863 161.028 40.2999 166.816C44.6903 169.574 48.4425 170.441 51.379 170.683C52.006 170.734 69.7826 179.296 69.7826 179.296L94.8333 182.007L103.293 169.179Z"
                    fill="url(#paint2_linear_3365_75719)"
                />
                <path
                    d="M111.113 93.7186L165.504 123.813C165.823 121.116 166.006 118.378 166.006 115.596C166.006 102.49 162.361 90.2368 156.031 79.7914L116.256 63.5042L111.113 93.7186Z"
                    fill="#E8D441"
                />
                <path
                    d="M165.397 124.659L58.3828 82.9272L54.3828 121.898L140.503 169.24C153.854 158.355 163.049 142.587 165.397 124.659Z"
                    fill="white"
                />
                <path
                    d="M69.7832 179.297C78.0897 182.827 87.2268 184.782 96.8214 184.782C107.473 184.782 117.559 182.37 126.571 178.071L73.6493 156.583L69.7832 179.297Z"
                    fill="#A6A7DC"
                />
                <path
                    d="M54.0695 132.771C48.3044 123.788 46.7888 123.964 47.4055 118.007C47.9827 112.432 41.7604 111.162 40.2849 117.856C38.6485 125.281 41.63 132.482 43.1772 134.247C43.1772 134.247 38.3132 143.666 44.3318 151.453C50.8902 159.939 55.0997 160.612 55.0997 160.612C55.0997 160.612 61.4429 143.384 54.0695 132.771Z"
                    fill="#FAD8B4"
                />
                <path
                    d="M37.1451 140.858L29.7156 137.804C26.8189 136.483 25.0895 133.403 25.9992 130.991C26.9088 128.578 30.0403 127.94 32.8515 129.487L39.7862 132.838C42.2761 133.918 43.3324 136.742 42.4942 139.078C41.9607 140.565 39.3916 141.882 37.1451 140.858Z"
                    fill="#FAD8B4"
                />
                <path
                    d="M34.6411 148.185L25.9739 145.083C23.1127 144.069 21.3787 141.289 22.242 138.923C23.1053 136.557 26.1714 135.687 28.9534 136.918L37.3379 140.796C39.5068 141.756 40.6143 144.089 39.9 146.046C39.1856 148.004 36.8719 148.976 34.6411 148.185Z"
                    fill="#FAD8B4"
                />
                <path
                    d="M33.8245 155.023L26.8382 153.685C24.1777 153.108 21.5631 150.647 22.6253 147.651C23.451 145.321 25.0555 144.61 29.1892 145.878L37.5287 148.305C38.1389 148.417 39.3392 150.462 38.7602 152.385C38.181 154.308 36.0072 155.496 33.8245 155.023Z"
                    fill="#FAD8B4"
                />
                <path
                    d="M30.8102 161.508L28.0484 160.778C25.5324 160.091 23.8856 157.827 24.4725 155.75C25.0593 153.672 27.6198 152.702 30.0907 153.549L34.8993 155.38C36.9504 156.083 38.1819 158.281 37.6384 159.877C36.8474 162.201 35.0913 162.42 30.8102 161.508Z"
                    fill="#FAD8B4"
                />
                <path
                    d="M166.007 142.533C165.923 142.533 165.837 142.525 165.751 142.509C165.024 142.369 164.547 141.665 164.686 140.937C172.25 101.59 187.886 84.1108 188.547 83.3863C189.045 82.8417 189.892 82.7988 190.443 83.2998C190.989 83.7991 191.029 84.6478 190.53 85.1959C190.373 85.3689 174.73 102.916 167.324 141.444C167.201 142.086 166.637 142.533 166.007 142.533Z"
                    fill="#E2E2F6"
                />
                <path
                    d="M194.035 81.6589C196.029 81.6589 197.645 80.0423 197.645 78.0481C197.645 76.0539 196.029 74.4373 194.035 74.4373C192.04 74.4373 190.424 76.0539 190.424 78.0481C190.424 80.0423 192.04 81.6589 194.035 81.6589Z"
                    fill="#E2E2F6"
                />
                <path
                    d="M155.349 168.028C155.285 168.028 155.22 168.021 155.157 168.008C154.674 167.901 154.367 167.425 154.472 166.942C157.837 151.505 172.894 133.885 173.533 133.142C173.855 132.767 174.42 132.726 174.796 133.048C175.171 133.37 175.212 133.935 174.89 134.31C174.736 134.488 159.488 152.332 156.222 167.322C156.13 167.742 155.76 168.028 155.349 168.028Z"
                    fill="#E2E2F6"
                />
                <path
                    d="M165.399 120.675C171.654 113.002 183.341 106.128 190.869 111.517C202.165 119.602 188.536 141.731 186.227 144.659C180.297 152.181 173.269 157.545 167.847 159.358C162.204 161.244 158.538 160.377 155.461 157.495C147.991 148.16 159.144 128.348 165.399 120.675Z"
                    fill="#E2E2F6"
                />
                <path
                    d="M143.666 130.276C148.982 139.521 149.608 147.934 149.232 152.784C148.901 156.91 145.474 160.749 141.348 160.812C132.998 160.955 124.72 156.069 117.202 148.005C109.694 139.942 105.926 129.909 106.212 124.092C106.499 118.266 109.971 112.342 117.882 110.919C126.563 109.362 136.551 117.908 143.666 130.276Z"
                    fill="#E2E2F6"
                />
                <path
                    d="M136.998 95.2258C131.959 145.329 145.122 152.154 150.251 152.606C160.513 153.51 171.007 133.867 175.609 100.592C180.212 67.3174 160.891 65.9881 160.891 65.9881C149.454 63.2823 139.012 75.2054 136.998 95.2258Z"
                    fill="#E2E2F6"
                />
                <g opacity="0.5">
                    <path
                        opacity="0.5"
                        d="M136.998 95.2258C131.959 145.329 145.122 152.154 150.251 152.606C160.513 153.51 171.007 133.867 175.609 100.592C180.212 67.3174 160.891 65.9881 160.891 65.9881C149.454 63.2823 139.012 75.2054 136.998 95.2258Z"
                        fill="#BDBDE6"
                    />
                </g>
                <path
                    d="M147.71 168.028C147.364 168.028 147.033 167.824 146.887 167.487C140.79 153.332 134.62 145.435 128.09 137.073L127.506 136.326C127.202 135.935 127.271 135.374 127.66 135.069C128.05 134.769 128.612 134.832 128.917 135.223L129.501 135.971C136.105 144.426 142.343 152.411 148.532 166.778C148.727 167.232 148.518 167.759 148.064 167.954C147.948 168.004 147.828 168.028 147.71 168.028Z"
                    fill="#A6A7DC"
                />
                <g opacity="0.5">
                    <g opacity="0.5">
                        <path
                            opacity="0.5"
                            d="M143.666 130.276C148.982 139.521 149.608 147.934 149.232 152.784C148.901 156.91 145.474 160.749 141.348 160.812C132.998 160.955 124.72 156.069 117.202 148.005C109.694 139.942 105.926 129.909 106.212 124.092C106.499 118.266 109.971 112.342 117.882 110.919C126.563 109.362 136.551 117.908 143.666 130.276Z"
                            fill="#BDBDE6"
                        />
                    </g>
                </g>
                <path
                    opacity="0.1"
                    d="M135.928 119.612C136.674 145.638 144.771 151.444 149.253 152.448C149.576 147.552 148.865 139.317 143.666 130.276C141.345 126.24 138.716 122.616 135.928 119.612Z"
                    fill="#6264A7"
                />
                <path
                    d="M151.371 164.409C150.897 164.409 150.501 164.035 150.477 163.558C148.828 129.995 154.525 97.0816 154.581 96.7528C154.667 96.2663 155.141 95.9383 155.617 96.0266C156.106 96.1122 156.431 96.5755 156.345 97.0628C156.287 97.3891 150.626 130.114 152.265 163.468C152.289 163.963 151.909 164.383 151.416 164.407C151.401 164.407 151.385 164.409 151.371 164.409Z"
                    fill="#A6A7DC"
                />
                <path
                    d="M170.282 200.5C173.797 199.305 176.318 196.108 176.318 192.341L168.718 164.365C168.62 163.893 168.146 163.514 167.659 163.514H134.408C133.92 163.514 133.447 163.893 133.349 164.365L125.748 192.341C125.748 196.109 128.269 199.305 131.784 200.5H170.282Z"
                    fill="#C8C6C4"
                />
                <path
                    d="M44.994 8.51367C45.2923 8.51367 45.5906 8.68515 45.7071 9.02829C46.6384 11.7714 48.3573 14.1424 50.6211 15.8577C51.0179 16.1585 51.0418 16.7135 50.6672 17.0418C48.4235 19.0094 46.7024 21.5525 45.733 24.4432C45.6096 24.8111 45.3022 24.995 44.9946 24.995C44.6872 24.995 44.3797 24.8111 44.2563 24.4433C43.2867 21.5526 41.5659 19.0093 39.3215 17.0417C38.9471 16.7134 38.9706 16.1584 39.3676 15.8575C41.6311 14.1423 43.35 11.7712 44.2809 9.0282C44.3976 8.68515 44.6957 8.51367 44.994 8.51367Z"
                    fill="#FAE969"
                />
            </g>
            <defs>
                <radialGradient
                    id="paint0_radial_3365_75719"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(59.7511 50.6886) rotate(3.11654) scale(24.9867)">
                    <stop stopColor="#9B643D" />
                    <stop offset="0.440581" stopColor="#BF916B" />
                    <stop offset="0.799088" stopColor="#D7B089" />
                    <stop offset="1" stopColor="#E0BB95" />
                </radialGradient>
                <radialGradient
                    id="paint1_radial_3365_75719"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(13.5464 73.3216) rotate(3.11654) scale(20.5047)">
                    <stop stopColor="#9B643D" />
                    <stop offset="0.3666" stopColor="#AF7C55" />
                    <stop offset="0.7106" stopColor="#BB8A63" />
                    <stop offset="1" stopColor="#BF8F68" />
                </radialGradient>
                <linearGradient
                    id="paint2_linear_3365_75719"
                    x1="27.957"
                    y1="136.491"
                    x2="42.1584"
                    y2="146.834"
                    gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E0AD95" />
                    <stop offset="1" stopColor="#FAD8B4" />
                </linearGradient>
                <clipPath id="clip0_3365_75719">
                    <rect width="197.293" height="200" fill="white" transform="translate(0.353516 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
};
